import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Box, Grid, Card, Button, Avatar } from '@mui/material';
import { Build, Phone } from '@mui/icons-material';
import Layout from '../components/Layout';

const glassStyle = {
  background: 'rgba(255, 255, 255, 0.25)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.18)',
  borderRadius: '16px',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)'
};

const Hardscaping = () => {
  return (
    <Layout>
      <Helmet>
        <title>Hardscaping Vancouver BC | Patio Installation West Vancouver | Retaining Walls North Vancouver</title>
        <meta name="description" content="Professional hardscaping Vancouver BC. Patio installation, retaining walls, stone work in West Vancouver & North Vancouver. Licensed contractors. Free quotes (604) 202-0053" />
        <meta name="keywords" content="hardscaping vancouver, patio installation west vancouver, retaining walls north vancouver, stone work vancouver bc, interlocking pavers vancouver, walkway installation bc" />
        <link rel="canonical" href="https://greenmountainlandscaping.ca/hardscaping" />
      </Helmet>
      
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/images/348s (1).jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: -2
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(27, 94, 32, 0.8) 0%, rgba(46, 125, 50, 0.7) 100%)',
            zIndex: -1
          }
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ ...glassStyle, p: { xs: 3, md: 6 }, color: 'white', textAlign: 'center' }}>
            <Avatar sx={{ bgcolor: 'white', color: 'primary.main', width: 80, height: 80, mx: 'auto', mb: 3 }}>
              <Build sx={{ fontSize: 40 }} />
            </Avatar>
            <Typography variant="h1" component="h1" sx={{ mb: 3, textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              Professional Hardscaping Vancouver BC
            </Typography>
            <Typography variant="h5" sx={{ mb: 4, opacity: 0.9 }}>
              Create stunning outdoor living spaces with expert stone work
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button variant="contained" size="large" href="tel:+16042020053" startIcon={<Phone />} sx={{ bgcolor: 'white', color: 'primary.main' }}>
                (604) 202-0053
              </Button>
              <Button variant="outlined" size="large" href="/#contact" sx={{ borderColor: 'white', color: 'white' }}>
                Get Free Hardscaping Quote
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Typography variant="h1" component="h1" sx={{ mb: 4, color: 'primary.main' }}>
          Professional Hardscaping Vancouver BC
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem' }}>
          Create stunning outdoor living spaces with expert <strong>hardscaping in Vancouver</strong>. Green Mountain Landscaping specializes in patio installation, retaining walls, and stone work throughout West Vancouver, North Vancouver, and Metro Vancouver.
        </Typography>

        <Typography variant="h2" component="h2" sx={{ mb: 3, color: 'primary.main' }}>
          Complete Hardscaping Services Vancouver
        </Typography>

        <Grid container spacing={4} sx={{ mb: 6 }}>
          {[
            { title: 'Patio Installation West Vancouver', desc: 'Custom outdoor living spaces with premium materials' },
            { title: 'Retaining Walls North Vancouver', desc: 'Functional and beautiful landscape solutions' },
            { title: 'Natural Stone Work Vancouver', desc: 'Expert craftsmanship with natural materials' },
            { title: 'Interlocking Pavers BC', desc: 'Durable and attractive paver installations' },
            { title: 'Walkway Installation Vancouver', desc: 'Beautiful pathways and garden walks' },
            { title: 'Outdoor Kitchen Construction', desc: 'Complete outdoor cooking and dining areas' }
          ].map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ 
                ...glassStyle, 
                p: 3, 
                height: '100%',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-4px)' }
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', mr: 2, width: 48, height: 48 }}>
                    <Build />
                  </Avatar>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>{service.title}</Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">{service.desc}</Typography>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography variant="h3" component="h3" sx={{ mb: 3, color: 'primary.main' }}>
          Best Hardscaping Company in Vancouver
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4 }}>
          Our <strong>patio installation West Vancouver</strong> and hardscaping services are designed to withstand BC's climate while creating beautiful, functional outdoor spaces. We use premium materials and proven techniques for lasting results.
        </Typography>

        <Box sx={{ textAlign: 'center', mt: 6, p: 4, bgcolor: 'primary.main', borderRadius: 4, color: 'white' }}>
          <Typography variant="h4" sx={{ mb: 2 }}>Ready for Beautiful Hardscaping?</Typography>
          <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>Transform your outdoor space with professional stone work</Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="contained" size="large" href="tel:+16042020053" sx={{ bgcolor: 'white', color: 'primary.main' }}>
              Call (604) 202-0053
            </Button>
            <Button variant="outlined" size="large" href="/#contact" sx={{ borderColor: 'white', color: 'white' }}>
              Get Free Hardscaping Quote
            </Button>
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};

export default Hardscaping;